/**
 * True when the frontend build targets the production environment — the same
 * production tier the backend's guard uses (`prod-background` has no frontend).
 *
 * A function, not a constant, so the router-composition and sidebar specs can
 * flip the environment per test. Load-bearing for feature behavior: it gates
 * the activity-bank asset-upload entry points (LX-1062), which the backend
 * refuses off production.
 */
export const isProductionEnv = (): boolean => import.meta.env.VITE_APP_ENV === 'production';
